

import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang( '@shining3d/xl-design-order' );

// 设计单状态
export const transferState = [
	{ label: $t( 'design.order.waitAccept' ), value: 'waitAccept' , class: 'blue-color'}, // 待接单
	{ label: $t( 'design.order.inDesign' ), value: 'inDesign', class: 'blue-color' }, // 设计中
	{ label: $t( 'design.order.pause' ), value: 'pause', class: 'red-color' }, // 暂停中
	{ label: $t( 'design.order.waitCheck' ), value: 'waitCheck', class: 'gray-color' }, // 待验收
	{ label: $t( 'design.order.waitRecover' ), value: 'waitRecover', class: 'green-color' }, // 待恢复设计
	{ label: $t( 'design.order.waitConfirmDesign' ), value: 'waitConfirmDesign', class: 'green-color' }, // 待确认设计
	{ label: $t( 'design.order.waitRedesign' ), value: 'waitRedesign', class: 'green-color' }, // 待重新设计
	// { label: $t( 'design.order.complete' ), value: 'designComplete' }, // 设计完成
    { label: $t( 'design.order.waitSettle' ), value: 'designComplete', class: 'green-color' }, // 设计完成，设计单展示成待结算
	{ label: $t( 'design.order.waitSettle' ), value: 'waitSettle', class: 'green-color' }, // 待结算
	{ label: $t( 'design.order.settling' ), value: 'settling', class: 'green-color' }, // 结算中
	{ label: $t( 'design.order.settleComplete' ), value: 'settleComplete', class: 'gray-color' }, // 已结算
	{ label: $t( 'design.order.refuse' ), value: 'refuse', class: 'red-color' }, // 已拒绝
	{ label: $t( 'design.order.cancel' ), value: 'cancel', class: 'gray-color' }, // 已取消
];